import { registerBlockType } from '@wordpress/blocks';

import { __ } from '@wordpress/i18n';

// import './style.scss';

/**
 * Internal dependencies
 */
import './style.css';
import './editor.css';
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { RxGroup as icon } from "react-icons/rx";
import { variations } from './variationPicker';
import advancejson from '@vayu-blocks/advance-panel/advance.json';
import settings from './settings/settings.json';
import style from './style/style.json';
import transforms from './transforms';
const { name } = metadata;

registerBlockType(name, {
    ...metadata, 
    attributes: {
        ...metadata.attributes, // Keep existing attributes from block.json
        ...advancejson, // Add attributes from advanceSettings.json
        ...settings,
        ...style,
    },
    example: {},
    transforms,
    icon,
    edit,
    save,
    variations,
});